<template>
	<div class="banner">
		<h1 class="banner-content">
			<slot></slot>
		</h1>
	</div>
</template>

<script>
export default {};
</script>

<style lang="css">
.banner {
	width: 100%;
	height: 100px;
	line-height: 100px;
	/* background: ghostwhite; */
}
</style>